import React from "react";
import { SvgProps } from "../../types";

// "#F6142D" - red "#FF9D00" - yellow "#55B938" - green

export const NotifyManIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 22 22"
      className={props.classNames?.join(" ") || ""}
    >
      <path
        d="M14.6667 10.9997H18.3334M16.5 12.833V9.16634M3.66669 16.4997V15.583C3.66669 14.8537 3.95642 14.1542 4.47214 13.6385C4.98787 13.1227 5.68734 12.833 6.41669 12.833H10.0834C10.8127 12.833 11.5122 13.1227 12.0279 13.6385C12.5436 14.1542 12.8334 14.8537 12.8334 15.583V16.4997C12.8334 16.7428 12.7368 16.9759 12.5649 17.1479C12.393 17.3198 12.1598 17.4163 11.9167 17.4163H4.58335C4.34024 17.4163 4.10708 17.3198 3.93517 17.1479C3.76326 16.9759 3.66669 16.7428 3.66669 16.4997ZM11 7.33301C11 8.06235 10.7103 8.76183 10.1946 9.27755C9.67884 9.79328 8.97937 10.083 8.25002 10.083C7.52068 10.083 6.8212 9.79328 6.30548 9.27755C5.78975 8.76183 5.50002 8.06235 5.50002 7.33301C5.50002 6.60366 5.78975 5.90419 6.30548 5.38846C6.8212 4.87274 7.52068 4.58301 8.25002 4.58301C8.97937 4.58301 9.67884 4.87274 10.1946 5.38846C10.7103 5.90419 11 6.60366 11 7.33301Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
